import React, { useState } from 'react';
import { Label, Search } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { some } from 'lodash';
import { useGetOrganisationsByTenant } from '../../apollo/queries/GetOrganisationsByTenant.queries';
import { SearchPair } from '../Roles/hooks/useRoles';
import { AdminOrg } from '../../pages/EditAdminUser/hooks/useGetAdminByIdState';
import { StyledLabelContainer } from '../OrganisationEditorModal/OrganisationEditorModal';

interface Props {
  selectedTenantCode: string;
  selectedOrganisations: AdminOrg[];
  onChange: (organisations: SearchPair[]) => void;
}

const allOrgOption = { key: '*', value: 'All Organizations' };

const StyledContainer = styled.div<{ width: string }>`
  display: flex;
  width: ${({ width }) => width};
  flex-direction: column;

  > div:nth-child(3) {
    height: 350px;
  }
`;

const OrganisationByTenantDropdown = (props: Props) => {
  const { selectedTenantCode, selectedOrganisations, onChange } = props;
  const { organisations } = useGetOrganisationsByTenant(selectedTenantCode);
  const [searchText, setSearchText] = useState('');

  const filteredOrganisations = () =>
    organisations.filter((o) =>
      o.name.toLowerCase().includes(searchText.trim().toLowerCase()),
    );

  const generatePair = (orgs: any[]) =>
    orgs.map((org) => {
      if (org.code === '*') {
        return allOrgOption;
      } else {
        return {
          key: org.code,
          value: org.name,
        };
      }
    });

  const allOrganizations = [
    allOrgOption,
    ...generatePair(filteredOrganisations()),
  ];

  const handleOnChange = (selectedOptions: SearchPair[]) => {
    const hasAllOrgOption = some(selectedOptions, allOrgOption);
    if (hasAllOrgOption) {
      onChange([allOrgOption]);
    } else {
      onChange(selectedOptions);
    }
  };

  return (
    <StyledContainer width="350px">
      <StyledLabelContainer>
        <Label title="Organisations" />
      </StyledLabelContainer>
      <Search
        showOptionsOnInputFocus
        showToggleIcon
        onChange={handleOnChange}
        onInputChange={setSearchText}
        options={allOrganizations}
        selectedOptions={generatePair(selectedOrganisations)}
      />
    </StyledContainer>
  );
};

export default OrganisationByTenantDropdown;
